module.exports = __webpack_public_path__ + "static/media/HP_Semler_2026_PDF.0dd02794.pdf";